var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { validateIconType } from './utils';
import { createComponent, styled } from '@workday/canvas-kit-react/common';
import { Box } from '@workday/canvas-kit-react/layout';
var StyledIconSpan = styled(Box.as('span'))({
    display: 'inline-block',
    '> svg': { display: 'block' },
}, function (_a) {
    var shouldMirror = _a.shouldMirror, styles = _a.styles;
    return (__assign({ transform: shouldMirror ? 'scaleX(-1)' : undefined }, styles));
});
export var Svg = createComponent('span')({
    displayName: 'Svg',
    Component: function (_a, ref, Element) {
        var src = _a.src, type = _a.type, elemProps = __rest(_a, ["src", "type"]);
        try {
            validateIconType(src, type);
        }
        catch (e) {
            console.error(e);
            return null;
        }
        return (React.createElement(StyledIconSpan, __assign({ as: Element, dangerouslySetInnerHTML: { __html: src.svg } }, elemProps, { ref: ref })));
    },
});
